import { ServerFetch } from '../main-model'

export default class JournalListModel extends ServerFetch {
    getJournalListBy = (data) => this.authFetch({
        url: 'journal-list/getJournalListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}